module.exports = __webpack_public_path__ + "@/assets/img/es-ciber.17388691.png";